import { useDebugValue, useEffect, useRef, useState } from "react";
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle, ChartLegend, ChartValueAxis, ChartValueAxisItem } from "@progress/kendo-react-charts";
import { AgGridReact } from "ag-grid-react";

import chartBtn from "../../../../../Images/chartBtn.svg";
import gridBtn from "../../../../../Images/gridBtn.svg";
import { sbaAxios } from "../../../../utils/sbaAxios";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { DeleteAssetBMSetting, allocationDetailsById, getAllocationDetByDateId, getPDFReport } from "../../../../../config/apiConfig";
import { getCurrencyFormat, getPercentageFormat } from "../../../../utils/conversionMethods";
import { LoadingScreen } from "../../../../UiComponents/LoadingComponent";
import { SBDatePicker } from "../../../../UiComponents/SBDatePicker";
import { DateRangePicker } from "rsuite";
import { SBDateRangePicker } from "../../../../UiComponents/SBDateRangePicker";

export const AllocationDetails = ({ProfromaID}) => {

  const [detailsGridData, setDetailsGridData] = useState([]);
  const [detailsChartData, setDetailsChartData] = useState([]);
  const [detailsColumnDef, setDetailsColumnDef] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [dateRange,setDateRange]=useState([null,null]);
  const [render,setRender]=useState(false);
  const [apiResponse,setApiResponse]=useState(null);
  const [fundReturns,setFundReturns]=useState(true);
  const [strategyReturns,setStrategyReturns]=useState(false);
  const [strategyWeight,setStrategyWeight]=useState(false);

  useEffect(() => {
    if (ProfromaID ) {
      if(dateRange[0] && dateRange[1])
      getAllocationDetailsByDateRange(ProfromaID, false ,getDateString(dateRange[0]) ,getDateString(dateRange[1]));
      else
      {
        getAllocationDetails(ProfromaID);
      }
      
    }
  }, [ProfromaID,render]);

  useEffect(()=>{
    if(apiResponse)
    {
      updateColumns(apiResponse);
    }
  },[fundReturns,strategyReturns,strategyWeight])

  const getAllocationDetailsByDateRange = (profromaId, status ,startDate,endDate) => {
    setDetailsLoading(true);
    sbaAxios({ url: `${getAllocationDetByDateId}/${profromaId},${startDate},${endDate}`, method: "get" }).then(response => {
      updateColumns(response);
      setApiResponse(response);
      setDetailsLoading(false);
    }).catch(error => {
      setDetailsChartData([]);
      setDetailsGridData([]);
      setDetailsColumnDef([]);
      setDetailsLoading(false);
    });
  };
  const getAllocationDetails = (profromaId) => {
    setDetailsLoading(true);
    sbaAxios({ url: `${allocationDetailsById}/${profromaId},${false}`, method: "get" }).then(response => {
      updateColumns(response);
      setApiResponse(response);
      setDetailsLoading(false);
    }).catch(error => {
      setDetailsChartData([]);
      setDetailsGridData([]);
      setDetailsColumnDef([]);
      setDetailsLoading(false);
    });
  };

  
  const updateColumns=(response)=>{
    const entityColumns = [...response?.EntityColumns]?.map(item => {
      return {
        field: (item.EntityId).toString(),
        headerName: item.Name,
        filter: "agTextColumnFilter",
        valueFormatter: (e) => { return getPercentageFormat(e.value) },
        type: 'rightAligned',
        headerTooltip: item.Name,

      }
    }) || [];
    const entityRORColumns = [...response?.EntityColumns]?.map(item => {
      return {
        field: (item.EntityId).toString()+'ROR',
        headerName: item.Name + "- ROR",
        filter: "agTextColumnFilter",
        valueFormatter: (e) => { return getPercentageFormat(e.value) },
        type: 'rightAligned',
        headerTooltip: item.Name,

      }
    }) || [];
    const strategyweightColumns = response?.StrategyColumns?.map(item => {
      return {
        field: (item.Name).toString() +'-Weight',
        headerName: item.Name + '-Weight',
        filter: "agTextColumnFilter",
        type: 'rightAligned',
        headerTooltip: item.Name,
        valueFormatter:(e) => { return getPercentageFormat(e.value) }
      }
    }) || [];
    const strategyColumns = response?.StrategyColumns?.map(item => {
      return {
        field: (item.Name).toString(),
        headerName: item.Name,
        filter: "agTextColumnFilter",
        type: 'rightAligned',
        headerTooltip: item.Name,
        valueFormatter:(e) => { return getPercentageFormat(e.value) }
      }
    }) || [];
    // const fundReturnColumns=response.
    const allocationDetails = response?.AllocationDetails || []
    const dataArray = allocationDetails.map((item) => {
      let eachRow = {
        ReturnDate: moment(item.AllocDate).format('MM/DD/YYYY'),
        TotalPortfolioWeight: item.TotalPortfolioWeight,
        TotalPortfolioReturn: item.TotalPortfolioReturn,
        PortfolioBMV: item.PortfolioBMV,
        PortfolioEMV: item.PortfolioEMV
      };
      item.CalcItems.forEach((element, index) => {
        eachRow = { ...eachRow, [element.EntityId+"ROR"]: element.Return.RoR , [element.EntityId]: element.EntityWeight };
      });
      item.StrategyItems.forEach((element, index) => {
        eachRow = { ...eachRow, [element.StrategyName]: element.StrategyReturn, [element.StrategyName +"-Weight"]: element.StrategyWeight };
      })
      return eachRow;
    });
    const cummulativedetails = response?.CumulativeReturns || [];
    setDetailsChartData(cummulativedetails);
    setDetailsGridData([...dataArray])
    let additionalColumn=[];
    if(strategyReturns)
    {
      additionalColumn=[...additionalColumn, ...strategyColumns];
    }
    if(strategyWeight)
    {
      additionalColumn=[...additionalColumn, ...strategyweightColumns];
    }
    if(fundReturns)
    {
       additionalColumn=[...additionalColumn, ...entityRORColumns];
    }
    setDetailsColumnDef([{
      field: "ReturnDate",
      headerName: "Date",
      pinned: 'left',
    }, ...entityColumns, {
      field: "TotalPortfolioWeight",
      headerName: "Total Portfolio Weight",
      type: 'rightAligned' ,
      headerTooltip: "Total Portfolio Weight",
      valueFormatter: (e) => { return getPercentageFormat(e.value) },
    }, {
      field: "TotalPortfolioReturn",
      headerName: "Total Portfolio Return",
      type: 'rightAligned',
      headerTooltip: "Total Portfolio Return",
      valueFormatter:(e) => { return getPercentageFormat(e.value) }
    }, {
      field: "PortfolioBMV",
      headerName: "Portfolio BMV",
      type: 'rightAligned',
      headerTooltip: "Portfolio BMV",
      valueFormatter:(e) => { return getCurrencyFormat(e.value,2) }
    }, {
      field: "PortfolioEMV",
      headerName: "Portfolio EMV",
      type: 'rightAligned' ,
      headerTooltip: "Portfolio EMV",
      valueFormatter:(e) => { return getCurrencyFormat(e.value,2) }
    },...additionalColumn]);
    setDetailsLoading(false);
  };
  
  const udpateDateRange=(e)=>{
    setDateRange([e.value.start,e.value.end]);
  };
  const resetValue=()=>{
    setDateRange([null,null]);
    setFundReturns(true);
    setStrategyWeight(false);
    setStrategyReturns(false);
  };
  function downloadFile(url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = ''; // You can set the desired filename here
    anchor.click();
}

const downloadReport = () => {
  let reportUrl = '';
  setDetailsLoading(true);

  if (dateRange[0] && dateRange[1]) {
      reportUrl = `${getPDFReport}?hypoId=${ProfromaID}&supressStrategyline=false&supressTotalline=false&sType=Report2&StartDate=${getDateString(dateRange[0])}&EndDate=${getDateString(dateRange[1])}&bExcel=false`;
  } else {
      reportUrl = `${getPDFReport}?hypoId=${ProfromaID}&supressStrategyline=false&supressTotalline=false&sType=Report2&StartDate=${getDateString(new Date(apiResponse.FromDate))}&EndDate=${getDateString(new Date(apiResponse.ToDate))}&bExcel=false`;
  }

  sbaAxios({
      url: reportUrl,
      method: 'GET',
      responseType: 'blob', // Ensure the response type is blob
  })
  .then((response) => {
      setDetailsLoading(false);

      // Log the response for debugging purposes
      console.log('Response:', response);

      // Ensure the response data is a Blob
     
      const blobUrl = window.URL.createObjectURL(response);
          // Create an anchor element and trigger the download
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'ProformaConstructionReport2.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Revoke the blob URL to free up memory
          window.URL.revokeObjectURL(blobUrl);
  
  })
  .catch((error) => {
      setDetailsLoading(false);
      console.error('Error downloading report:', error);
  });
};








  return (
    <>
      <div className="row">
        <div className="col-lg-3">
          <h2 className="fw-bold fs-6 mb-4">Search Filter</h2>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-3">
          <span className="fw-medium">Select Date Range</span>
          <SBDateRangePicker
            value={{ start: dateRange[0], end: dateRange[1] }}
            onChange={(e) => { udpateDateRange(e) }}
            onKeyDown={(e)=>{if(e.code==="Enter"){setRender(value=>!value)}}}
          />
          {/* <DateRangePicker
                    className="SbaDateRage text-dark"
                    placeholder="Select Date Range"
                    value={dateRange}
                    format="MM/dd/yyyy"
                    block
                    character=" - "
                    onChange={(e) => { udpateDateRange(e) }}
                    onKeyDown={(e)=>{if(e.code==="Enter"){setRender(value=>!value)}}}
                    style={{border:'none' ,'--rs-color-red':'#fff' , '--rs-state-error':'#e5e5ea'}}

                /> */}
        </div>
        <div className="col-md-2 row-items">
          <span className="fw-medium">
            <input type="checkbox" className=" me-2"  checked={strategyReturns} onChange={(e)=>{setStrategyReturns(e.target.checked)}}/>
            Strategy Returns
          </span>
        </div>
        <div className="col-md-2 row-items">
          <span className="fw-medium">
            <input type="checkbox" className="me-2"  checked={fundReturns} onChange={(e)=>{setFundReturns(e.target.checked)}} />
            Fund Returns</span>
        </div>
        <div className="col-md-2 d-flex row-items">
          <span className="fw-medium">
            <input type="checkbox" className="me-2" checked={strategyWeight} onChange={(e)=>{setStrategyWeight(e.target.checked)}} />
            Strategy Weight</span>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-3">
          <button className="s-sm-btn mx-1" onClick={()=>{resetValue()}} >Clear</button>
          <button className="p-sm-btn mx-1" onClick={()=>{setRender(value=>!value)}}> Apply</button>
        </div>
      </div>
      <div className="mt-2">
        {detailsLoading ? <><LoadingScreen/></> :
                  <GridChart gridRowData={detailsGridData}  downloadReport={()=>{downloadReport()}} columnDefs={detailsColumnDef} dataLoading={detailsLoading} chartData={detailsChartData} />}
          </div>
    </>
  );
};
export const GridChart = ({ columnDefs, gridRowData, dataLoading, chartData ,downloadReport}) => {
  const [showChart, setShowChart] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [CData,setCData]=useState(chartData)
  const detailsRef = useRef();
  
  useEffect(()=>{
    setCData(chartData);
  },[chartData]);


  useEffect(() => {
    if (dataLoading) {
      if(detailsRef.current)
      detailsRef.current?.api.showLoadingOverlay();
    }
  }, [dataLoading])

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    minWidth:200,
    flex:1
    };
    const detailsExcel = () => {
        if (detailsRef.current) {
            const params = {
                skipHeader: false,
                columnGroups: false,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: true,
                fileName: 'ProformaConstructionReport2.xlsx',
            };
            detailsRef.current.api.exportDataAsExcel(params);
        }
    };
  return <>
    <div className="d-flex">
      <div>
        <label className="fw-medium">List of Details</label>
      </div>
      <div className="mx-4">
        <button
          className={`toggle-btn rounded-start ${showGrid && "active"}`}
          onClick={() => { setShowGrid(true); setShowChart(false) }}
        >
          <span>
            <img
              src={gridBtn}
              alt=""
              style={{
                filter: showGrid
                  ? "brightness(100%)"
                  : "brightness(0)",
              }}
            />
          </span>
        </button>
        <button
          className={`toggle-btn rounded-end ${showChart && "active"}`}
          onClick={() => { setShowGrid(false); setShowChart(true) }}
          disabled
        >
          <span>
            <img
              src={chartBtn}
              alt=""
              style={{
                filter: showChart
                  ? "brightness(100%)"
                  : "brightness(0)",
              }}
            />
          </span>
        </button>
      </div>
          {showGrid && <div className="ms-auto">
              <button className="p-sm-btn mx-1" onClick={detailsExcel}>Excel Download</button>
        <button className="p-sm-btn mx-1" onClick={()=>{downloadReport()}} >PDF Download</button>
      </div>}
    </div>
    <div>
      <div
        className="ag-theme-alpine"
        style={{ width: "100%", height: "350px" }}
      >
        {showGrid &&
         <><DetailsGrid gridRowData={gridRowData} columnDefs={columnDefs} defaultColDef={defaultColDef} detailsRef={detailsRef} dataLoading={dataLoading}/></>}
        {(showChart) &&
          <> {!dataLoading ? <DetailsCharts ChartData={CData}/> :<><LoadingScreen/></>}</> 
        }
      </div>
    </div>
  </>
};
export const DetailsCharts = ({ ChartData }) => {
  const [postiveNegativeReturn, setPostiveNegativeReturns] = useState(ChartData);
  const [stepCount,setStepCount]=useState(1);
  useEffect(() => {
    setPostiveNegativeReturns(ChartData);
    if(ChartData.length > 50)
    setStepCount(5);
    else if(ChartData.length > 100)
    setStepCount(10);
    else if(ChartData.length > 200)
    setStepCount(12);
    else if (ChartData.length > 300)
    setStepCount(14);
  }, []);
  useEffect(()=>{setPostiveNegativeReturns(ChartData)},[ChartData]);
  const posNegRor = postiveNegativeReturn.map((item) => ({
    value: item.Ror,
  })) || [];
  const pointLength = posNegRor.length + 1;
  const posRor = postiveNegativeReturn.map((item) => ({
    value: item.Ror > 0 ? (item.Ror * 100) : 0,
  })) || [];
  const negRor = postiveNegativeReturn.map((item) => ({
    value: item.Ror < 0 ? (item.Ror * 100) : 0,
  })) || [];
  const uniqueCategories = postiveNegativeReturn.map((item) => moment(item.ReturnDate).format('MMM YYYY')) || [];
  return (
    <>
      <div style={{ height: '0px' }}>
        <svg xmlns="https://www.w3.org/2000/svg" version="1.1" style={{ width: '0', height: '0', visibility: 'hidden' }}>
          <defs>
            <linearGradient id="svg-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="100%" style={{ stopColor: '#C2EAE2' }} />
              <stop offset="0%" style={{ stopColor: '#FFFFFF' }} />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div style={{ width: '100%', height: '400px' }}>
        <Chart>
          <ChartTitle />
          <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={uniqueCategories}
              title={{ visible: false }}
              line={{ visible: false }}
              labels={{
                step: stepCount,
                rotation: 90,
                position: 'start'
              }}
              justified={true}
              majorGridLines={{ visible: false }}
              axisCrossingValue={[0, pointLength, pointLength, 0]}
              color="#7D7D7D"
            />
          </ChartCategoryAxis>
          <ChartSeries>
            <ChartSeriesItem
              type="column"
              data={posRor}
              field="value"
              justified={true}
              color='#05BFDB'
              markers={{ visible: false }}
              tooltip={{ visible: true }}
              axis="primary"
              name="Positive Returns" />
            <ChartSeriesItem
              type="column"
              data={negRor}
              field="value"
              justified={true}
              color='#FF8686'
              markers={{ visible: false }}
              tooltip={{ visible: true }}
              axis="primary"
              name="Negative Returns" />
          </ChartSeries>
          <ChartLegend position="bottom" visible={true} />
          <ChartValueAxis>
            <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0}%', position: 'right' }} majorGridLines={{ visible: false }} />
            <ChartValueAxisItem name="secondary" color="#7D7D7D" line={{ visible: true, axis: 'right' }} majorGridLines={{ visible: false }} />
          </ChartValueAxis>
        </Chart>
      </div>
    </>)
};
export const DetailsGrid=({gridRowData,columnDefs,defaultColDef,detailsRef,dataLoading})=>{
  return <>
  <AgGridReact
  rowData={gridRowData}
  columnDefs={columnDefs}
  defaultColDef={defaultColDef}
  animateRows={true}
  ref={detailsRef}
  overlayLoadingTemplate={dataLoading ? '<div class="ag-overlay-loading-center">Loading...</div>' : ''}
  enableBrowserTooltips={true} 
/></>
};
const getDateString=(obj)=>{
  const month=obj.getMonth()+1;
  const date=obj.getDate();
  const year=obj.getFullYear();
  // return obj.toISOString();
  return `${year}-${month}-${date}`;
}

